module.exports = __webpack_public_path__ + "static/media/swim.32cab999.png";